import {
    DefaultMeshCellSettings,
    MeshCellColor
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshCellSettings';

export enum MeshCellBorderSide
{
    Top = 'Top',
    Left = 'Left',
    Right = 'Right',
    Bottom = 'Bottom',
}

export enum MeshCellBorderType
{
    None = 'None',
    Grid = 'Grid',
    Thin = 'Thin',
    Medium = 'Medium',
    Dashed = 'Dashed',
    Dotted = 'Dotted',
    Thick = 'Thick',
    Double = 'Double',
    Hair = 'Hair',
    Medium_dashed = 'Medium dashed',
    Dash_dot = 'Dash dot',
    Medium_dash_dot = 'Medium dash dot',
    Dash_dot_dot = 'Dash dot dot',
    Medium_dash_dot_dot = 'Medium dash dot dot',
    Slanted_dash_dot = 'Slanted dash dot',

}

export class MeshCellBorder
{
    public constructor(public type:MeshCellBorderType,
                       public color:MeshCellColor)
    {
    }

    static fromBorder(border:MeshCellBorder, isGridlinesVisible:boolean):MeshCellBorder
    {
        let newType;
        let newColor;

        if( !border || border.type == MeshCellBorderType.Grid )
        {
            newType = MeshCellBorderType.Grid;
            newColor = isGridlinesVisible ? DefaultMeshCellSettings.gridColor : 'none';
        }

        if( border && border.type != MeshCellBorderType.Grid )
        {
            newType = border.type;
            newColor = border.color;
        }

        return new MeshCellBorder(newType, newColor);
    }
}
